// Top navigation + footer

const HexPin = ({size = 22}) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path fillRule="evenodd" clipRule="evenodd" d="M12 1 L21.5 6.5 L21.5 17.5 L12 23 L2.5 17.5 L2.5 6.5 Z M12 8 L15.46 10 L15.46 14 L12 16 L8.54 14 L8.54 10 Z" fill="currentColor"/>
  </svg>
);

const Nav = () => (
  <header className="nav">
    <div className="container nav-inner">
      <a href="#" className="nav-logo">
        <span className="logo-mark"><HexPin size={16}/></span>
        Byggro
      </a>
      <nav className="nav-links">
        <a href="#funktioner">Funktioner</a>
        <a href="#produkt">Produkt</a>
        <a href="#priser">Priser</a>
        <a href="#kunder">Kunder</a>
        <a href="#faq">Vanliga frågor</a>
      </nav>
      <div style={{display:'flex', gap:8, alignItems:'center'}}>
        <a href="https://app.byggro.com/signin" className="btn btn-ghost">Logga in</a>
        <a href="#demo" className="btn btn-primary">Boka demo<span className="arr"/></a>
      </div>
    </div>
  </header>
);

const Footer = () => (
  <footer className="site-footer">
    <div className="container">
      <div className="footer-grid" style={{gridTemplateColumns:'2fr 1fr 1fr'}}>
        <div>
          <div className="nav-logo footer-logo" style={{marginBottom:14}}>
            <span className="logo-mark"><HexPin size={16}/></span>
            Byggro
          </div>
          <p className="footer-copy">
            Sälj- och beräkningssystem för hantverkare. Affärer, offerter och projekt — på ett ställe.
          </p>
        </div>
        <FCol title="Produkt" items={["Affärer","Offerter","Projekt","Priser"]}/>
        <div className="footer-col">
          <div className="footer-col-title">Byggro</div>
          <div className="footer-links">
            <a href="#demo">Kontakta oss</a>
            <a href="#" onClick={(e) => { e.preventDefault(); window.dispatchEvent(new CustomEvent('open-legal', {detail:'villkor'})); }}>Villkor</a>
            <a href="#" onClick={(e) => { e.preventDefault(); window.dispatchEvent(new CustomEvent('open-legal', {detail:'integritet'})); }}>Integritet</a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div>© 2026 Byggro AB</div>
      </div>
    </div>
  </footer>
);

const FCol = ({title, items}) => (
  <div className="footer-col">
    <div className="footer-col-title">{title}</div>
    <div className="footer-links">
      {items.map(i => <a key={i} href="#">{i}</a>)}
    </div>
  </div>
);

Object.assign(window, { Nav, Footer });
